<!-- eslint-disable -->
<template>
    <div class="minimal-auth-wrapper">
        <div class="auth-container">
            <!-- Logo Section -->
            <div class="logo-section" v-if="app.logo">
                <b-img :src="app.logo" alt="Logo" class="brand-logo" />
            </div>

            <!-- Login Card -->
            <div class="login-card">
                <!-- Header -->
                <div class="login-header">
                    <h1 class="login-title">Iniciar sesión</h1>
                    <p class="login-subtitle">
                        Ingresa tu correo electrónico para continuar
                    </p>
                </div>

                <!-- Form -->
                <validation-observer ref="loginForm" #default="{ invalid }">
                    <b-form class="login-form" @submit.prevent="sendMagicLink">
                        <!-- Email Input -->
                        <b-form-group class="form-group">
                            <label for="email" class="form-label">Email</label>
                            <validation-provider
                                #default="{ errors }"
                                name="Email"
                                rules="required|email"
                            >
                                <b-form-input
                                    id="email"
                                    v-model="userEmail"
                                    name="login-email"
                                    :state="errors.length > 0 ? false : null"
                                    placeholder="tu@ejemplo.com"
                                    class="form-input"
                                    autofocus
                                />
                                <small class="error-text" v-if="errors[0]">{{
                                    errors[0]
                                }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- Submit Button -->
                        <b-button
                            v-if="!isLoading"
                            variant="primary"
                            type="submit"
                            block
                            :disabled="invalid"
                            class="submit-btn"
                        >
                            Continuar
                        </b-button>

                        <b-button
                            v-if="isLoading"
                            variant="primary"
                            disabled
                            block
                            class="submit-btn"
                        >
                            <b-spinner small class="mr-2" />
                            Enviando...
                        </b-button>

                        <!-- Info Text -->
                        <div class="info-text">
                            <feather-icon icon="InfoIcon" size="16" />
                            <span
                                >Te enviaremos un enlace seguro a tu
                                correo</span
                            >
                        </div>
                    </b-form>
                </validation-observer>
            </div>

            <!-- Payment Methods -->
            <div class="payment-methods">
                <p class="payment-label">Métodos de pago</p>
                <div class="payment-images">
                    <b-img
                        :src="imgFooter"
                        alt="Tarjetas"
                        class="payment-img"
                    />
                    <b-img
                        :src="imgPayPal"
                        alt="PayPal"
                        class="payment-img-paypal"
                    />
                </div>
            </div>

            <!-- Footer -->
            <div class="page-footer">
                <feather-icon icon="LockIcon" size="14" />
                <span>Conexión segura</span>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { email, required } from "@validations";
import {
    BAlert,
    BButton,
    BCard,
    BCardText,
    BCardTitle,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BImg,
    BLink,
    BRow,
    BSpinner,
    VBTooltip,
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import LoginSessions from "./LoginSessions.vue";

export default {
    directives: {
        "b-tooltip": VBTooltip,
    },
    components: {
        BRow,
        BCol,
        BButton,
        BForm,
        BFormInput,
        BFormGroup,
        BCard,
        BCardTitle,
        BLink,
        BCardText,
        BSpinner,
        BAlert,
        ValidationProvider,
        ValidationObserver,
        ToastificationContent,
        BImg,
        LoginSessions,
    },
    data() {
        return {
            userEmail: "",
            required,
            email,
            isLoading: false,
            app: {
                banner: "",
                nombre: "",
                logo: "",
            },
            imgFooter: require("@/assets/images/logo/footer-card.png"),
            imgPayPal: require("@/assets/images/logo/paypal.png"),
        };
    },
    created() {
        this.$http
            .get("/get-env")
            .then((response) => {
                this.app.banner = response.data.data.app_banner;
                this.app.name = response.data.data.app_name;
                this.app.logo = response.data.data.app_logo;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    mounted() {
        this.userEmail =
            this.$route.params.email != "undefined"
                ? this.$route.params.email
                : null;
    },
    methods: {
        sendMagicLink() {
            this.$refs.loginForm.validate().then((success) => {
                if (success) {
                    this.isLoading = true;

                    useJwt
                        .sendMagicLink(this.userEmail)
                        .then((response) => {
                            this.isLoading = false;
                            this.showToast(
                                response.data.message,
                                "success",
                                "MailIcon"
                            );
                            // Redirigir a página de confirmación
                            this.$router.push({
                                name: "magic-link-sent",
                                params: { email: this.userEmail },
                            });
                        })
                        .catch((error) => {
                            this.isLoading = false;
                            this.$swal({
                                title: "Error",
                                text:
                                    error.response?.data?.message ||
                                    error.message,
                                icon: "error",
                            });
                        });
                }
            });
        },
        showToast(message, variant, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: message,
                    variant: variant,
                    icon: icon,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/pages/page-auth.scss";

// Minimal Auth Wrapper
.minimal-auth-wrapper {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafbfc;
    padding: 2rem;
}

// Auth Container
.auth-container {
    width: 100%;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

// Logo Section
.logo-section {
    margin-bottom: 3rem;

    .brand-logo {
        max-width: 180px;
        max-height: 180px;
        display: block;
    }
}

// Login Card
.login-card {
    width: 100%;
    background: #ffffff;
    border: 1px solid #e1e4e8;
    border-radius: 8px;
    padding: 2rem;
    margin-bottom: 2rem;
}

// Login Header
.login-header {
    margin-bottom: 2rem;

    .login-title {
        font-size: 1.5rem;
        font-weight: 600;
        color: #24292e;
        margin: 0 0 0.5rem 0;
        letter-spacing: -0.02em;
    }

    .login-subtitle {
        font-size: 0.875rem;
        color: #586069;
        margin: 0;
        line-height: 1.5;
    }
}

// Login Form
.login-form {
    .form-group {
        margin-bottom: 1.5rem;
    }

    .form-label {
        display: block;
        font-size: 0.875rem;
        font-weight: 600;
        color: #24292e;
        margin-bottom: 0.5rem;
    }

    .form-input {
        height: 44px;
        padding: 0.625rem 0.75rem;
        font-size: 0.875rem;
        line-height: 1.5;
        color: #24292e;
        background-color: #ffffff;
        border: 1px solid #d1d5da;
        border-radius: 6px;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

        &:focus {
            border-color: #0366d6;
            outline: none;
            box-shadow: 0 0 0 3px rgba(3, 102, 214, 0.1);
        }

        &::placeholder {
            color: #959da5;
        }

        &.is-invalid {
            border-color: #d73a49;

            &:focus {
                border-color: #d73a49;
                box-shadow: 0 0 0 3px rgba(215, 58, 73, 0.1);
            }
        }
    }

    .error-text {
        display: block;
        margin-top: 0.375rem;
        font-size: 0.75rem;
        color: #d73a49;
    }
}

// Submit Button
.submit-btn {
    height: 44px;
    padding: 0.625rem 1rem;
    font-size: 0.875rem;
    font-weight: 600;
    color: #ffffff !important;
    background-color: #24292e;
    border: 1px solid rgba(27, 31, 35, 0.15);
    border-radius: 6px;
    transition: background-color 0.2s ease;

    &:hover:not(:disabled) {
        background-color: #1b1f23;
        border-color: rgba(27, 31, 35, 0.15);
    }

    &:focus {
        box-shadow: 0 0 0 3px rgba(36, 41, 46, 0.1);
    }

    &:active:not(:disabled) {
        background-color: #181b1f;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

// Info Text
.info-text {
    margin-top: 1rem;
    padding: 0.75rem;
    background-color: #f6f8fa;
    border: 1px solid #e1e4e8;
    border-radius: 6px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.75rem;
    color: #586069;
    line-height: 1.4;

    svg {
        flex-shrink: 0;
        color: #0366d6;
    }
}

// Payment Methods
.payment-methods {
    width: 100%;
    padding: 1.5rem 0;
    text-align: center;

    .payment-label {
        font-size: 0.75rem;
        color: #6a737d;
        margin: 0 0 1rem 0;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        font-weight: 600;
    }

    .payment-images {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.75rem;

        .payment-img {
            max-width: 260px;
            height: auto;
            opacity: 0.7;
        }

        .payment-img-paypal {
            max-width: 80px;
            height: auto;
            opacity: 0.7;
        }
    }
}

// Page Footer
.page-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    font-size: 0.75rem;
    color: #6a737d;

    svg {
        color: #28a745;
    }
}

// Responsive Design
@media (max-width: 576px) {
    .minimal-auth-wrapper {
        padding: 1rem;
    }

    .auth-container {
        max-width: 100%;
    }

    .logo-section {
        margin-bottom: 2rem;

        .brand-logo {
            max-width: 100px;
            max-height: 100px;
        }
    }

    .login-card {
        padding: 1.5rem;
    }

    .login-header {
        margin-bottom: 1.5rem;

        .login-title {
            font-size: 1.25rem;
        }
    }

    .payment-methods {
        padding: 1rem 0;

        .payment-images {
            .payment-img {
                max-width: 220px;
            }
        }
    }
}

@media (max-width: 360px) {
    .login-card {
        padding: 1.25rem;
    }

    .payment-images {
        .payment-img {
            max-width: 200px;
        }

        .payment-img-paypal {
            max-width: 70px;
        }
    }
}
</style>
